import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Menu, { MenuLinkImage } from './Menu';
import FlyoutMenu, { FlyoutToggle } from './FlyoutMenu';
import ConditionalWrap from '../ConditionalWrap';

import menuIcon from '../../images/ic-menu-blue.svg';

const BurgerMenu = props => {
  const { children, collapsed, menuId } = props;
  return (
    <ConditionalWrap
      condition={collapsed}
      wrap={children => (
        <Menu>
          <FlyoutMenu
            menuId={menuId}
            closeOnMouseLeave={props.closeOnMouseLeave}
          >
            <FlyoutToggle center alignIcon="center" withArrow={false}>
              <MenuLinkImage src={menuIcon} alt="" />
            </FlyoutToggle>
            {React.Children.map(children, child => child.props.children)}
          </FlyoutMenu>
        </Menu>
      )}
    >
      {children}
    </ConditionalWrap>
  );
};

BurgerMenu.propTypes = {
  menuId: PropTypes.string.isRequired,
  collapsed: PropTypes.bool,
  /** Makes the menu close when the cursor is outside of the menu area */
  closeOnMouseLeave: PropTypes.bool,
  children: PropTypes.node,
};

BurgerMenu.defaultProps = {
  collapsed: false,
};

BurgerMenu.Menu = styled.div``;

export default BurgerMenu;
